angular.module('picmonicng').filter('leadTitle', [
  'MarketOptionsConfig',
  function (MarketOptionsConfig) {
    return function (lead) {
      return MarketOptionsConfig.getMarketById(lead).name;
    };
  },
]);
